import React from 'react';
import './Legal.css';

export default function PrivacyPolicy() {
    return (
        <div className="legal-page animate-in">
            <header className="legal-header">
                <h1>Política de Privacidad</h1>
                <p className="subtitle">Cuidado de tus datos y de tu confianza</p>
            </header>

            <div className="legal-content glass-card">
                <section>
                    <h2>1. Recolección de datos</h2>
                    <p>
                        Recolectamos identificación laboral básica (por ejemplo, código de empleado)
                        y datos de bienestar percibido en el trabajo (ánimo, fatiga, percepciones del clima).
                        Si tu empresa activa módulos opcionales de acompañamiento multimodal, pueden
                        generarse índices o vectores numéricos a partir de cámara o micrófono;
                        por diseño no se almacenan video ni audio en el servidor.
                    </p>
                </section>

                <section>
                    <h2>2. Finalidad del tratamiento</h2>
                    <p>Tus datos se utilizan para:</p>
                    <ul>
                        <li>Acompañarte en la jornada y facilitar conversaciones de apoyo a tiempo.</li>
                        <li>Detectar cambios en condiciones de trabajo (Estado Funcional), no para juzgar veracidad.</li>
                        <li>Sugerir rutas de cuidado (por ejemplo, ritual EPA) cuando aplique.</li>
                        <li>Generar lecturas agregadas de clima y prevención para líderes (sin sanción automática).</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Confidencialidad y límites</h2>
                    <p>
                        Tus respuestas individuales se tratan con confidencialidad. Las alertas buscan
                        cuidar la seguridad y el bienestar del equipo según reglas configurables de la
                        organización. ALINEA no es un diagnóstico médico ni psicológico, ni un detector
                        de mentiras o veracidad; tampoco toma decisiones de despido o sanción de forma
                        automática. Las lecturas son organizacionales y preventivas: señal, hipótesis e
                        incertidumbre no sustituyen el juicio humano ni un acto clínico.
                    </p>
                </section>

                <section>
                    <h2>4. Biometría opcional</h2>
                    <p>
                        Cámara y micrófono son opcionales: puedes omitirlos y seguir usando ALINEA.
                        Si aceptas, el procesamiento preferente ocurre en tu dispositivo; solo se
                        conservan señales numéricas (índices / vectores) necesarias para el
                        acompañamiento y el Estado Funcional, con consentimiento. No se usa biometría
                        para diagnóstico clínico.
                    </p>
                </section>

                <section>
                    <h2>5. Tus derechos</h2>
                    <p>
                        Tienes derecho a conocer, actualizar y rectificar tus datos personales, y a
                        oponerte al uso de cámara o micrófono, a través de RRHH o el administrador
                        de tu empresa, según la política interna de tu organización.
                    </p>
                </section>
            </div>

            <div className="legal-footer">
                <button type="button" onClick={() => window.history.back()} className="btn btn-primary">
                    Volver
                </button>
            </div>
        </div>
    );
}
